<div [formGroup]="form" fxFlex="100%" fxLayout="row wrap"> 
    <div [ngStyle.gt-sm]="'width: 30%'" [ngStyle.lt-sm]="'width: 90%'" fxLayout="column">
        <mat-label class="font-weight-400">{{'REPORT.FILTERS.DATEFROM' | translate}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="always" color="accent" class="mr-8">
            <input matInput 
                [matDatepicker]="dateFromControl" 
                [placeholder]="placeholder"
                [min]="minDate"
                formControlName="dateFrom" [readonly]="readonly" [required]="required" (keydown)="handleKeyDown($event)">
            <mat-datepicker-toggle 
                matSuffix 
                [for]="dateFromControl" [disabled]="readonly">
            </mat-datepicker-toggle>                                
            <mat-datepicker #dateFromControl disabled="false"></mat-datepicker>
        </mat-form-field>
    </div>

    <div [ngStyle.gt-sm]="'width: 30%'" [ngStyle.lt-sm]="'width: 90%'" fxLayout="column">
        <mat-label class="font-weight-400">{{"REPORT.FILTERS.DATETO" | translate}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="always" color="accent" class="mr-8">
            <input matInput 
                [matDatepicker]="dateToControl" 
                [placeholder]="placeholder"
                [min]="minDate"
                formControlName="dateTo" [readonly]="readonly" (keydown)="handleKeyDown($event)">
            <mat-datepicker-toggle 
                matSuffix 
                [for]="dateToControl">
            </mat-datepicker-toggle>                                
            <mat-datepicker #dateToControl disabled="false"></mat-datepicker>
        </mat-form-field>
    </div>

    <div [ngStyle.gt-sm]="'width: 30%'" [ngStyle.lt-sm]="'width: 90%'" fxLayout="column">
        <mat-label class="font-weight-400">{{"REPORT.FILTERS.DATE_RANGE" | translate}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="always" color="accent" class="mr-8">
            <input matInput formControlName="calculatedDays" class="p-4">
        </mat-form-field>
    </div>

</div>